import { useData } from "../useData";
// import { useCRUD } from "./useCRUD";
import type { StProperty } from "@/types";
import { stPropertyRepository } from "@/repositories/StPropertyRepository";

export function useStaysProperties(filters?: {
  search?: string;
  status?: "active" | "hidden" | "inactive" | "draft";
  sortBy?: string;
  sortOrder?: "asc" | "desc";
  page?: number;
  limit?: number;
  owner_id?: string;
  showDeleted?: boolean;
}) {
  const { data, isLoading, error, refetch } = useData<StProperty>({
    repository: stPropertyRepository,
    fetcher: (repo) => repo.getAll(filters),
    queryKey: ["st_properties", JSON.stringify(filters)],
  });

  // const {
  //   create,
  //   update,
  //   delete: softDelete,
  //   restore,
  //   isCreating,
  //   isUpdating,
  //   isDeleting,
  //   isRestoring,
  // } = useCRUD<StProperty, StPropertyInsert, StPropertyUpdate>({
  //   repository: stPropertyRepository,
  //   queryKey: ["st_properties", JSON.stringify(filters)],
  //   messages: {
  //     createSuccess: "Propriedade criada com sucesso.",
  //     updateSuccess: "Propriedade atualizada com sucesso.",
  //     deleteSuccess: "Propriedade excluída com sucesso.",
  //     restoreSuccess: "Propriedade restaurada com sucesso.",
  //   },
  // });

  return {
    stProperties: data ?? [],
    isLoading,
    error,
    refetch,
    // createStaysProperty: create,
    // updateStaysProperty: update,
    // softDelete,
    // restore,
    // isCreating,
    // isUpdating,
    // isDeleting,
    // isRestoring,
  };
}
